"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throwingValidationResult = void 0;
/**
 * A throwingValidationResult is just a function that receives the result of a validation, either the value itself, or an Error if the validation failed.
 * If an Error is received, the error is thrown. If not, the value is returned.
 *
 * @returns {(value: InputType, error?: Error) => InputType} A function that will either return the validated value, or throw the failed validation Error.
 */
function throwingValidationResult() {
    return (value, error) => {
        if (error) {
            throw error;
        }
        return value;
    };
}
exports.throwingValidationResult = throwingValidationResult;
